import type { Action } from '@atlassian/react-sweet-state';
import type {
	ObjectActivityTimelineState,
	ContainerProps,
} from '../../../../common/types/store.tsx';
import {
	type ObjectCommentEvent,
	OBJECT_COMMENT_EVENT,
} from '../../../../common/types/timeline-event.tsx';

/**
 * Internal action to update the in-memory representation of a single comment
 * event. Should NOT perform any network requests.
 */
export const updateCommentStateById =
	(
		commentId: string,
		updatedCommentData: Partial<ObjectCommentEvent>,
	): Action<ObjectActivityTimelineState, ContainerProps> =>
	async ({ setState, getState }) => {
		const existingEvents = getState().timelineEvents ?? [];
		setState({
			timelineEvents: [
				...existingEvents.map((event) => {
					if (event.type === OBJECT_COMMENT_EVENT && event.data.id === commentId) {
						return {
							...event,
							data: {
								...event.data,
								...updatedCommentData,
							},
						};
					}
					return event;
				}),
			],
		});
	};
